import { defaultOrganizationBlobSettings } from '../constants/constants';
import { useOrganizationSettings } from '../useOrganizationSettings/useOrganizationSettings';
import useOrganizationSettingsGlobalPayrollUpdate from '../useOrganizationSettingsGlobalPayrollUpdate/useOrganizationSettingsGlobalPayrollUpdate';
import useSettingsUpdate from '../useSettingsUpdate/useSettingsUpdate';

const defaultSettings = defaultOrganizationBlobSettings.global.payroll.gusto;

export default function useOrganizationSettingsGlobalGustoUpdate() {
  const settings = useOrganizationSettings()?.global?.payroll?.gusto ?? defaultSettings;
  const updateSettings = useOrganizationSettingsGlobalPayrollUpdate();
  return useSettingsUpdate(settings, updateSettings, 'gusto');
}
